module.exports = "<div class=\"m-panel\">\n   <button class=\"m-panel-btn\"></button>\n   <div class=\"m-panel-controls\"></div>\n</div>";